var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var ChevronRight = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 5 8" }),
        React.createElement("path", { d: "M4.5,6.5 C4.32934044,6.5 4.15868089,6.4300025 4.0286863,6.29072176 L0.695491855,2.71942073 C0.434836048,2.44014499 0.434836048,1.98873255 0.695491855,1.70945681 C0.956147661,1.43018106 1.37746344,1.43018106 1.63811925,1.70945681 L4.5,4.77577587 L7.36188075,1.70945681 C7.62253656,1.43018106 8.04385234,1.43018106 8.30450815,1.70945681 C8.56516395,1.98873255 8.56516395,2.44014499 8.30450815,2.71942073 L4.9713137,6.29072176 C4.84131911,6.4300025 4.67065956,6.5 4.5,6.5", transform: "rotate(-90 3.5 5)" })));
};
export default ChevronRight;
